import { createContext, useContext } from "react";

const ProjectSelectorContext = createContext(global?.project);

export const ProjectSelectorProvider = ProjectSelectorContext.Provider;

export function useProjectSelector() {
    return useContext(ProjectSelectorContext);
}
